import { useTranslation } from 'react-i18next';
import { useSiteContent } from './useSiteContent';

export const usePageContent = (pageId) => {
  const { i18n } = useTranslation();
  const { data, loading, error } = useSiteContent(pageId);

  // Get content for current language, fallback to French if missing
  const currentLangContent = data?.[i18n.language];
  const frenchContent = data?.fr;
  
  // Use current language content if available, otherwise fallback to French
  const content = currentLangContent || frenchContent;

  return {
    data,
    loading,
    error,
    content,
    hasContent: !!content,
    currentLanguage: i18n.language
  };
};
